<div style="width: 500px;">
    <div class="overlay-title">{{'bikeshop.modal.update_job_card.quote.create_inventory_item' |
        translate}}</div>

    <div class="row margin-top-16">
        <div class="col-md-4 label" [ngClass]="{'red bold': skuExists}">
            {{ 'bikeshop.products.sku' | translate }}
        </div>
        <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText
                   placeholder="{{ 'bikeshop.products.sku_placeholder' | translate }}" [(ngModel)]="product.sku"
                   (ngModelChange)="product.sku = $event.toUpperCase()" (keydown)="inputChanged()"
                   (focus)="editingSKU = true" (blur)="editingSKU = false"/>
            <div class="small" *ngIf="skuExists">{{ 'bikeshop.products.sku_already_taken' | translate }}</div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label" [ngClass]="{'red bold': !product.name}">
            {{ 'bikeshop.products.product_name' | translate }}
        </div>
        <div class="col-md-8 value">
            <input id="float-input" type="text" pInputText
                   placeholder="{{ 'bikeshop.products.product_name' | translate }}" [(ngModel)]="product.name"/>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label"
             [ngClass]="{'red bold': product.defaultPrice === null || product.defaultPrice === undefined || product.defaultPrice.length === 0 }">
            {{ 'bikeshop.products.default_price' | translate }}
        </div>
        <div class="col-md-6 value flex">
            <input currencyMask class="p-inputtext" [(ngModel)]="product.defaultPrice" [options]="currencyoptions"
                   placeholder="{{ (vatInclusive ? 'bikeshop.products.incl_vat' : 'bikeshop.products.excl_vat') | translate }}"/>
        </div>
    </div>
    <div class="row" style="margin-top: 8px">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8 flex">
            <small>
                ***{{ 'bikeshop.products.tax_explanation' | translate }}
            </small>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{ 'bikeshop.products.taxable' | translate }}
        </div>
        <div class="col-md-4 value">
            <p-inputSwitch [(ngModel)]="product.taxable"></p-inputSwitch>
        </div>
    </div>

    <div class="row margin-top-16">
        <div class="col-md-4 label"></div>
        <div class="col-md-8">
            <button pButton type="button" class="p-button-raised full-width" (click)="save()"
                    [disabled]="saving || !valid()"
                    label="{{'bikeshop.general.save'| translate}}"></button>
        </div>
    </div>

</div>
